import { Locale } from "antd/es/locale";
import kz_KZ from "antd/lib/locale/kk_KZ";
import ru_RU from "antd/lib/locale/ru_RU";
import en_EN from "antd/lib/locale/en_US";
import tr_TR from "antd/lib/locale/tr_TR";
import uz_UZ from "antd/lib/locale/uz_UZ";
import fr_FR from "antd/lib/locale/fr_FR";

export enum Language {
  RU = "RU",
  KK = "KK",
  EN = "EN",
  TR = "TR",
  UZ = "UZ",
  FR = "FR",
}

export const langTitle: Record<Language, string> = {
  [Language.RU]: "Русский",
  [Language.KK]: "Қазақ",
  [Language.EN]: "English",
  [Language.TR]: "Türkçe",
  [Language.UZ]: "O'zbek",
  [Language.FR]: "Français",
};

export type SurveyLanguage = {
  readonly langCode: string;
  readonly langName: string;
};

export const getSurveyLanguages = (languages: Array<Language>): Array<SurveyLanguage> => {
  return languages.map((lang) => ({
    langCode: lang,
    langName: langTitle[lang],
  }));
};

export const langLocale: Record<Language, Locale> = {
  [Language.KK]: kz_KZ,
  [Language.EN]: en_EN,
  [Language.RU]: ru_RU,
  [Language.TR]: tr_TR,
  [Language.UZ]: uz_UZ,
  [Language.FR]: fr_FR,
};

export const toKcLanguage: Record<Language, string> = {
  [Language.KK]: "kz",
  [Language.EN]: "en",
  [Language.RU]: "ru",
  [Language.TR]: "tr",
  [Language.UZ]: "uz",
  [Language.FR]: "fr",
};

export const defaultTexts: Record<Language, string> = {
  [Language.RU]: "Другое (уточните)",
  [Language.KK]: "Басқа (нақтылаңыз)",
  [Language.EN]: "Other (please specify)",
  [Language.TR]: "Diğer (lütfen belirtiniz)",
  [Language.UZ]: "Boshqa (iltimos, aniqlang)",
  [Language.FR]: "Autre (veuillez préciser)",
};
